enum USER_PATHS {
	USERS = "/v1/users",
	PROFILE_USER = "/v1/user-profile",
	USER_MANAGERS = "/v1/user-managers",
	USER_COUNT = "/v1/users/count",
	USER_CHANGE_COORDINATION = "/v1/user-requests",
	USER_CHANGE_PASSWORD_REQUEST = "/v1/user-pwd-requests/ack",
	USER_CHANGE_AVATAR = "/v1/users",
	USER_REQUESTS_PASSWORD = "/v1/user-pwd-requests",
	USER_REQUESTS_PASSWORD_COUNT = "/v1/user-pwd-requests/count",
	USER_DELETE = "/v1/users",
	USER_EDIT = "/v1/users",
	USER_UPDATE_STATUS = "/v1/users",
}

export default USER_PATHS;
